import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSendQuestionToApplicationMailMutation } from '../../../../redux/services/mail.jsx';
import { useToastMessages } from '../../../../hooks/useToastMessages.jsx';
import { Form as AntdForm } from 'antd';
import QuestionToApplicationForm from './QuestionToApplicationForm.jsx';

const QuestionToApplicationPage = () => {
  const [values, setValues] = useState(undefined);
  const { t, i18n } = useTranslation();
  const [form] = AntdForm.useForm();

  const { successMessage } = useToastMessages();

  const [sendQuestionToApplicationMail, { isSuccess: sendSuccess }] =
    useSendQuestionToApplicationMailMutation();

  useEffect(() => {
    document.title = t('Otázka k prihláške');
  }, []);

  useEffect(() => {
    if (sendSuccess) {
      successMessage({
        message: t('Ďakujeme za Vašu otázku!'),
        description: t('Vaša správa bola úspešne odoslaná.'),
      });
    }
  }, [sendSuccess]);

  useEffect(() => {
    if (values) {
      const locale =
        i18n.language ||
        (typeof navigator !== 'undefined' ? navigator.language : 'sk');

      sendQuestionToApplicationMail({ ...values, locale });
    }
  }, [values]);

  useEffect(() => {
    if (sendSuccess && form && form.resetFields) {
      form.resetFields();
    }
  }, [sendSuccess]);

  const initials = {
    name: undefined,
    email: undefined,
    title: undefined,
    text: undefined,
  };

  return (
    <div style={{ margin: '10px' }}>
      <QuestionToApplicationForm
        form={form}
        initialValues={initials}
        onFinish={setValues}
      />
    </div>
  );
};

export default QuestionToApplicationPage;
